import React, { useState, useEffect } from "react";
import { Form, Button, Modal, Popconfirm } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";

import { AddIcon, EditIcon, DeleteIcon } from 'components/Icons';
import { PrimaryButton } from 'components/Buttons';
import ZonesTable from 'components/Table/Zones';
import ZoneForm from 'components/Forms/Zones/Zone';
import { PAGE_SIZE } from "constants";

import { doGetAllZones, doUpdateZone, doCreateZone, doDeleteZone } from "modules/zone/stores/thunk";
import { selectAllZones } from "modules/zone/stores/slice";

const ZonesPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const query = queryString.parse(location.search);

  const { isFetching, status, metadata, item } = useSelector((state) => state.zone);
  const zones = selectAllZones(useSelector((state) => state));
  
  const [form] = Form.useForm();
  const currentPage = Number(query.currentPage) || 1;
  const itemsPerPage = Number(query.itemsPerPage) || PAGE_SIZE;
  const pagination = {
    current: currentPage,
    pageSize: itemsPerPage,
    total: metadata.totalItems,
    showTotal: (total) => `${total} Zoner`,
  };
  const [state, setState] = useState({
    visibleModal: false,
    action: "",
    zone: null,
  });

  useEffect(() => {
    if (!isFetching && status === "succeeded") {
      handleCancel();
    }
    // eslint-disable-next-line
  }, [isFetching]);

  useEffect(() => {
    if (item && status === "create_succeeded") {
      navigate(`/zones/${item._id}`);
    }
    // eslint-disable-next-line
  }, [item, status]);

  useEffect(() => {
    dispatch(doGetAllZones({ currentPage, itemsPerPage, ...query }));
    // eslint-disable-next-line
  }, []);

  const handleFilter = (params, updatePath) => {
    if (updatePath) {
      const searchParams = new URLSearchParams(params);
      navigate(`?${searchParams.toString()}`);
    }
    const currentPage = Number(params.currentPage) || 1;
    const itemsPerPage = Number(params.itemsPerPage) || PAGE_SIZE;
    dispatch(doGetAllZones({
      currentPage,
      itemsPerPage,
      ...params,
    }));
  };

  const handleTableChange = (params) => {
    handleFilter(params, true);
  };

  const handleDelete = (item) => {
    dispatch(doDeleteZone(item._id))
  };

  const withAction = (item) => {
    return (
      <div className="actions">
        <Popconfirm
          title="Radera zon"
          description="Är du säker på att du vill radera denna zon?"
          onConfirm={() => handleDelete(item)}
          okText="Ja"
          cancelText="Nej"
        >
          <Button type="text"><DeleteIcon /></Button>
        </Popconfirm>
        <Button
          type="link"
          className="edit"
          onClick={() => {
            handleClickAction("edit", item);
          }}
        >
          <EditIcon />
        </Button>
      </div>
    );
  };

  const handleClickAction = (action, item) => {
    form.resetFields();
    const params = {
      ...item,
      centerAddress: {
        address: item.centerAddress,
        latLng: { lat: item.centerLat, lng: item.centerLng },
      },
    };
    form.setFieldsValue(params);
    setState({
      ...state,
      action,
      zone: item,
      visibleModal: true,
    });
  };

  const handleSubmit = async (values) => {
    const params = setParams(values);
    console.log(params);
    if (state.zone) {
      await dispatch(doUpdateZone({ id: state.zone._id, ...params }));
    } else {
      await dispatch(doCreateZone(params));
    }
  };

  const handleCancel = () => {
    setState({ ...state, visibleModal: false });
    form.resetFields();
  };

  const setParams = (values) => {
    const params = { ...values };
    params.centerAddress = values.centerAddress?.address;
    params.centerLat = values.centerAddress?.latLng?.lat;
    params.centerLng = values.centerAddress?.latLng?.lng;
    params.countryCode = values.centerAddress?.countryCode;
    return params;
  };

  return (
    <div className="Content ZonesPage">
      <div className="ContentHeader">
        <div className="HeaderTitle">
          Zoner
        </div>
        <div className="HeaderToolBar">
          <div className="ToolBarButtons">
            {/* <SecondaryButton
              type="primary"
              label="Filter"
              icon={<FilterIcon />}
            /> */}
            <PrimaryButton
              type="primary"
              label="Ny Zon"
              icon={<AddIcon />}
              onClick={() => setState({ ...state, action: 'new', zone: null, file: null, visibleModal: true })}
            />
          </div>
        </div>
      </div>
      <div className="ContentMain">
        <ZonesTable
          rowKey="_id"
          loading={isFetching}
          query={query}
          withAction={withAction}
          pagination={pagination}
          dataSource={zones}
          onChange2={handleTableChange}
          scrollHeight="calc(100vh - 100px)"
          actionWidth={120}
        />
      </div>
      <Modal
        open={state.visibleModal}
        onCancel={handleCancel}
        footer={[]}
        width={408}
      >
        <ZoneForm
          form={form}
          isFetching={isFetching}
          zone={state.zone}
          handleSubmit={handleSubmit}
          handleCancel={handleCancel}
        />
      </Modal>
    </div>
  );
};

export default ZonesPage;
